
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1(673|887|92|938)|4(185|273|364)|7(120|408|639)|6(339|764|928)|2484|2875|8187|8733|9914)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
